import { Trans } from '@lingui/macro'
import { useState } from 'react'
import styled from 'styled-components/macro'
import { ExternalLink, ThemedText } from 'theme'

import { MouseoverTooltip } from '../Tooltip'

const StyledPolling = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: auto;
  padding: 1rem;
  transition: 250ms ease color;
`
const StyledPollingNumber = styled(ThemedText.Small)<{ hovering: boolean }>`
  transition: opacity 0.25s ease;
  :hover {
    opacity: 1;
  }

  a {
    color: unset;
  }
  a:hover {
    text-decoration: none;
    color: unset;
  }
`

export default function Polling() {
  const [isHover, setIsHover] = useState(false)

  //TODO - chainlink gas oracle is really slow. Can we get a better data source?

  return (
    <div className="d-flex flex-wrap" style={{ justifyContent: 'space-around' }}>
      <div>
        <ExternalLink href={'https://etherscan.io/token/0x0d2f366554ef1895173d6D5148E4fA50f9b0e5c9'}>
          <MouseoverTooltip text={<Trans>Blue Crystal smart contract. Click to view on explorer link.</Trans>}>
            <span>
              BLUE CRYSTAL: <span className="text-white">0x0d2f366554ef1895173d6D5148E4fA50f9b0e5c9</span>{' '}
            </span>
          </MouseoverTooltip>
        </ExternalLink>
      </div>
      <div>
        <ExternalLink href={'https://etherscan.io/token/0x5C6CBe357514E797EcAE008D316A64b87d81DE75'}>
          <MouseoverTooltip text={<Trans>Red Crystal smart contract. Click to view on explorer link.</Trans>}>
            RED CRYSTAL: <span className="text-white">0x5C6CBe357514E797EcAE008D316A64b87d81DE75</span>{' '}
          </MouseoverTooltip>
        </ExternalLink>
      </div>
    </div>
  )
}
